import { render, staticRenderFns } from "./ScriptCreate.vue?vue&type=template&id=4fecdb9b&scoped=true"
import script from "./ScriptCreate.vue?vue&type=script&lang=js"
export * from "./ScriptCreate.vue?vue&type=script&lang=js"
import style0 from "./ScriptCreate.vue?vue&type=style&index=0&id=4fecdb9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fecdb9b",
  null
  
)

export default component.exports